<template>
  <div>
    <FileTable :isAdmin="isAdmin" ref="fileTable" />
     <hr>
    <PerformanceByGrade :isAdmin="isAdmin" />
  </div>
</template>

<script>
import PerformanceByGrade from "./PerformanceByGrade.vue";
import FileTable from "./PerformanceCriteria.vue";
import store from "@/store/store";
export default {
  components: {
    FileTable,
    PerformanceByGrade
  },
  computed: {
    isAdmin() {
      const user = store.state.auth.user;
      return user && user.role === "admin";
    }
  },
  methods: {
    refreshFiles() {
      this.$refs.fileTable && this.$refs.fileTable.$forceUpdate();
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/PerformanceCriteria/index.vue